module.exports = __webpack_public_path__ + "img/Linda edmonds in university home ec club.1a1d8269.png";